export default function Size() {
    return (
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.01" x="0.756836" y="0.399414" width="58.6467" height="58.6467" fill="black" />
            <rect
                x="54.7734"
                y="11.9746"
                width="38.5833"
                height="49.3867"
                rx="2.44361"
                transform="rotate(90 54.7734 11.9746)"
                stroke="black"
                strokeWidth="2.74713"
                strokeMiterlimit="11.4737"
                strokeLinecap="square"
                strokeDasharray="7.33 7.33"
            />
            <rect
                x="50.1436"
                y="27.4082"
                width="23.15"
                height="40.1267"
                rx="2.44361"
                transform="rotate(90 50.1436 27.4082)"
                stroke="black"
                strokeWidth="2.74713"
                strokeMiterlimit="11.4737"
                strokeLinecap="square"
            />
            <rect
                x="35.4824"
                y="32.0381"
                width="6.17333"
                height="10.8033"
                transform="rotate(90 35.4824 32.0381)"
                stroke="black"
                strokeWidth="1.92917"
                strokeMiterlimit="11.4737"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <rect
                x="45.5137"
                y="32.0381"
                width="6.17333"
                height="6.17333"
                rx="0.771667"
                transform="rotate(90 45.5137 32.0381)"
                stroke="black"
                strokeWidth="1.92917"
                strokeMiterlimit="11.4737"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <circle cx="17.7341" cy="35.1248" r="3.08667" stroke="black" strokeWidth="1.92917" />
            <circle cx="30.0804" cy="45.1561" r="1.54333" fill="black" />
            <line x1="41.0759" y1="44.9636" x2="43.7767" y2="44.9636" stroke="black" strokeWidth="1.92917" strokeLinecap="round" />
            <line x1="16.3835" y1="44.9636" x2="19.0844" y2="44.9636" stroke="black" strokeWidth="1.92917" strokeLinecap="round" />
        </svg>
    );
}
